import { type SelectOption } from '../../../../../components';

export enum OFFER_STATUS {
  CREATED = 'CREATED',
  PROVISIONING_PENDING_RSF = 'PROVISIONING_PENDING_RSF',
  FAILED_READY_TO_RELEASE = 'FAILED_READY_TO_RELEASE',
  READY_TO_RELEASE = 'READY_TO_RELEASE',
  RELEASING = 'RELEASING',
  FAILED_RELEASING = 'FAILED_RELEASING',
  RELEASED = 'RELEASED',
  FAILED_RELEASED = 'FAILED_RELEASED',
  APPLICANT_ACCEPTED = 'APPLICANT_ACCEPTED',
  APPLICANT_REJECTED = 'APPLICANT_REJECTED',
  OVERDUE = 'OVERDUE',
  MEET_CONDITION_LAPSED = 'MEET_CONDITION_LAPSED',
  REVOKED = 'REVOKED',
  INVALID = 'INVALID',
}

// This text is only used for Notice of Offer
export const OFFER_STATUS_TEXT = {
  [OFFER_STATUS.CREATED]: 'Created',
  [OFFER_STATUS.PROVISIONING_PENDING_RSF]: 'Provisioning Pending RSF',
  [OFFER_STATUS.READY_TO_RELEASE]: 'Ready to Release',
  [OFFER_STATUS.RELEASING]: 'Releasing',
  [OFFER_STATUS.RELEASED]: 'Released',
  [OFFER_STATUS.APPLICANT_ACCEPTED]: 'Offer Accepted',
  [OFFER_STATUS.APPLICANT_REJECTED]: 'Offer Declined',
  [OFFER_STATUS.OVERDUE]: 'Offer Lapsed',
  [OFFER_STATUS.REVOKED]: 'Revoked',
  [OFFER_STATUS.INVALID]: 'Invalid',
  [OFFER_STATUS.MEET_CONDITION_LAPSED]: 'Meet Condition Lapsed',
  [OFFER_STATUS.FAILED_READY_TO_RELEASE]: 'Failed Ready to Release',
  [OFFER_STATUS.FAILED_RELEASING]: 'Failed Releasing',
  [OFFER_STATUS.FAILED_RELEASED]: 'Failed Released',
};

// Used for displaying status definition in staff table list
export const OFFER_STATUS_EXPLANATION_MAP: Partial<
  Record<OFFER_STATUS, string>
> = {
  [OFFER_STATUS.RELEASED]: 'Offer released, applicant has not acted yet.',

  [OFFER_STATUS.APPLICANT_ACCEPTED]: 'Applicant has accepted the offer.',

  [OFFER_STATUS.APPLICANT_REJECTED]: 'Applicant has declined the offer.',

  [OFFER_STATUS.OVERDUE]: 'Applicant does not accept within deadline',

  [OFFER_STATUS.MEET_CONDITION_LAPSED]:
    'Offer accepted, but condition not fulfilled within deadline.',
};

export const offerStatusOptions: SelectOption[] = Object.entries(
  OFFER_STATUS_TEXT,
).map(([key, value]) => ({
  value: key,
  label: value,
}));
